import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useI18n } from "../context/I18nContext";
import { Reveal } from "../components/shared";

export default function Gallery() {
  const { t } = useI18n();
  const [gallery, setGallery] = useState([]);
  const [filter, setFilter] = useState("All");
  useEffect(() => { api.get("/gallery").then(({ data }) => setGallery(data)).catch(() => {}); }, []);

  const cats = ["All", ...Array.from(new Set(gallery.map((g) => g.category)))];
  const items = filter === "All" ? gallery : gallery.filter((g) => g.category === filter);

  return (
    <div className="pt-28">
      <section className="max-w-7xl mx-auto px-6 py-12">
        <Reveal>
          <div className="text-coral font-semibold tracking-widest uppercase text-xs mb-3">Gallery</div>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold text-navy tracking-tight">{t.sections.galleryTitle}</h1>
          <p className="mt-5 text-lg text-navy/60 max-w-2xl">A peek into the bright spaces, joyful faces, and everyday adventures at Ainalem.</p>
        </Reveal>
        <div className="flex flex-wrap gap-2 mt-8">
          {cats.map((c) => (
            <button key={c} onClick={() => setFilter(c)} data-testid={`gallery-filter-${c}`}
              className={`px-4 py-2 rounded-full text-sm font-semibold transition-colors ${filter === c ? "bg-navy text-white" : "bg-white text-navy/70 hover:bg-navy/5 border border-black/5"}`}>{c}</button>
          ))}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 pb-12">
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-5 [column-fill:_balance]">
          {items.map((g, i) => (
            <Reveal key={g.id} delay={(i % 3) * 0.08} className="mb-5 break-inside-avoid">
              <div className="rounded-2xl overflow-hidden shadow-md group relative" data-testid={`gallery-item-${i}`}>
                <img src={g.url} alt={g.category} className="w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                <div className="absolute inset-0 bg-navy/0 group-hover:bg-navy/30 transition-colors flex items-end p-4">
                  <span className="text-white font-semibold opacity-0 group-hover:opacity-100 transition-opacity">{g.category}</span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
